const INTERNAL_EMAIL_DOMAINS = new Set(["chorusview.com", "chorussystems.net"]);

export function getAnalyticsUserRole(email: string): "internal" | "external" {
  const domain = email.split("@")[1]?.toLowerCase();
  return domain && INTERNAL_EMAIL_DOMAINS.has(domain) ? "internal" : "external";
}
